// import React, { useRef, useState, useEffect } from "react";
// import Checkbox from "../../../Checkbox";
// import ActionMenu from "./ActionMenu";
// import {
//   SpinnerIcon,
//   CheckIcon,
//   ClockIcon,
//   ErrorIcon,
//   DocumentIcon,
//   WhiteDocumentIcon,
//   SortIcon,
//   ThreeDotsIcon,
//   PreviewIcon,
//   RenameIcon,
//   DownloadIcon,
//   DeleteIcon,
//   ViewIngestIcon,
//   MoveToFolderIcon,
// } from "./Icons";
// import DynamicTags from "./DynamicTags";


// const DataTable = ({
//   displayedFiles,
//   loading,
//   isAllChecked,
//   handleSelectAll,
//   selectedContracts,
//   handleCheckboxChange,
//   getFileIcon,
//   removeFileExtension,
//   darkenColor,
//   openTagModalFor,
//   formatDate,
//   toggleActionMenu,
//   isActionMenuOpen,
//   setIsActionMenuOpen,
//   actionMenuPosition,
//   actionMenuRefs,
//   setSelectedFilePreview,
//   handleRenameClick,
//   handleDownload,
//   handleDelete,
//   handleViewAndIngest,
//   handleSingleMoveToFolder,
//   columnPreferences,
//   isFolderView = false,
//   isAllFilesView = false,
// }) => {
//   const tbodyRef = useRef(null);
//   const [activeSummaryId, setActiveSummaryId] = useState(null);
//   const summaryModalRef = useRef(null);

//   // Read from localStorage on mount. If empty, fallback to `{}` allowing Tailwind percentages.
//   const [columnWidths, setColumnWidths] = useState(() => {
//     try {
//       const savedWidths = localStorage.getItem("dataTable_columnWidths");
//       return savedWidths ? JSON.parse(savedWidths) : {};
//     } catch (error) {
//       console.error("Failed to load column widths", error);
//       return {};
//     }
//   });

//   const handleResize = (colName, e) => {
//     e.preventDefault();
//     e.stopPropagation();

//     // Get the current actual rendered width of the column header DOM element
//     const thElement = e.target.closest("th");
//     const startWidth = thElement
//       ? thElement.getBoundingClientRect().width
//       : 150;
//     const startX = e.clientX;

//     const onMouseMove = (moveEvent) => {
//       const newWidth = Math.max(80, startWidth + (moveEvent.clientX - startX));
//       setColumnWidths((prev) => ({ ...prev, [colName]: newWidth }));
//     };

//     const onMouseUp = () => {
//       document.removeEventListener("mousemove", onMouseMove);
//       document.removeEventListener("mouseup", onMouseUp);
//       document.body.style.cursor = "default";

//       // Save the latest widths to localStorage precisely when the user finishes dragging
//       setColumnWidths((latestWidths) => {
//         localStorage.setItem(
//           "dataTable_columnWidths",
//           JSON.stringify(latestWidths)
//         );
//         return latestWidths;
//       });
//     };

//     document.addEventListener("mousemove", onMouseMove);
//     document.addEventListener("mouseup", onMouseUp);
//     document.body.style.cursor = "col-resize";
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         summaryModalRef.current &&
//         !summaryModalRef.current.contains(event.target)
//       ) {
//         setActiveSummaryId(null);
//       }
//     };

//     if (activeSummaryId !== null) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [activeSummaryId]);

//   const toggleSummary = (id, e) => {
//     e.stopPropagation();
//     setActiveSummaryId((prevId) => (prevId === id ? null : id));
//   };

//   const defaultCols = [
//     { name: "name", visible: true, order: 0 },
//     { name: "status", visible: true, order: 1 },
//     { name: "tags", visible: true, order: 2 },
//     { name: "uploaded_at", visible: true, order: 3 },
//   ];

//   const activeColumns = (
//     columnPreferences && columnPreferences.length > 0
//       ? columnPreferences
//       : loading
//       ? []
//       : defaultCols
//   )
//     .filter((col) => col.visible === true || col.visible === "true")
//     .sort((a, b) => a.order - b.order);

//   const colSpanCount = 2 + (activeColumns.length || defaultCols.length);

//   const renderStatus = (item) => {
//     const rawStatus = item.status || (item.id ? "ready" : "uploading");
//     const statusLower = rawStatus.toLowerCase();
//     const displayLabel =
//       rawStatus.charAt(0).toUpperCase() + rawStatus.slice(1).replace(/_/g, " ");

//     let config = {
//       label: displayLabel,
//       color: "text-[#6A6A75]",
//       bg: "bg-[#F2F2F2]",
//       border: "border-[#52525B4D]",
//       icon: <SpinnerIcon />,
//       isSpinning: true,
//     };

//     if (
//       statusLower === "ready" ||
//       statusLower === "ingested" ||
//       statusLower === "completed"
//     ) {
//       config = {
//         label: displayLabel,
//         color: "text-[#0C7A2A]",
//         bg: "bg-[#BCE5C766]",
//         border: "border-[#00942866]",
//         icon: <CheckIcon />,
//         isSpinning: false,
//       };
//     } else if (statusLower === "ready_for_review") {
//       config = {
//         label: "Ready for review",
//         color: "text-[#B89A25]",
//         bg: "bg-[#FFFAE5]",
//         border: "border-[#D1A70066]",
//         icon: <ClockIcon />,
//         isSpinning: false,
//       };
//     } else if (statusLower === "error" || statusLower === "failed") {
//       config = {
//         label: displayLabel,
//         color: "text-red-700",
//         bg: "bg-red-50",
//         border: "border-red-200",
//         icon: <ErrorIcon />,
//         isSpinning: false,
//       };
//     }

//     return (
//       <span
//         title={config.label}
//         className={`inline-flex max-w-full font-outfit items-center gap-1.5 px-2.5 py-1 rounded-full border ${config.border} ${config.bg} ${config.color} text-[12px] font-medium`}
//       >
//         <span
//           className={`flex-shrink-0 flex items-center justify-center w-3.5 h-3.5 ${
//             config.isSpinning ? "animate-spin" : ""
//           }`}
//         >
//           {config.icon}
//         </span>
//         <span className="truncate">{config.label}</span>
//       </span>
//     );
//   };

//   // Helper to generate the inline style only if the user explicitly resized it
//   const getColStyle = (colName) => {
//     return columnWidths[colName]
//       ? {
//           width: columnWidths[colName],
//           minWidth: columnWidths[colName],
//           maxWidth: columnWidths[colName],
//         }
//       : {};
//   };

//   const columnDefs = {
//     name: {
//       header: (
//         <th
//           key="name"
//           style={getColStyle("name")}
//           className={`${
//             !columnWidths.name ? "w-[33%]" : ""
//           } relative px-4 text-[#00000080] font-outfit text-[13px] font-semibold border-b border-r border-[#0000001A]`}
//         >
//           Document
//           <div
//             onMouseDown={(e) => handleResize("name", e)}
//             className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#A259FF] transition-colors z-10"
//           />
//         </th>
//       ),
//       cell: (item) => (
//         <td
//           key={`name-${item.id}`}
//           style={getColStyle("name")}
//           className={`${
//             !columnWidths.name ? "w-[33%]" : ""
//           } px-4 py-2 border-b border-r border-[#0000001A] relative`}
//         >
//           <div className="flex items-center gap-3 min-w-0">
//             <img
//               src={getFileIcon(item)}
//               className="w-5 h-5 flex-shrink-0"
//               alt="Icon"
//             />
//             <span className="text-[#52525B] font-outfit text-[14px] font-medium truncate">
//               {removeFileExtension(item.name) || "N/A"}
//             </span>

//             {item.summary && (
//               <div className="relative">
//                 <button
//                   onClick={(e) => toggleSummary(item.id, e)}
//                   className="flex items-center justify-center flex-shrink-0 w-[22px] h-[22px] rounded-full bg-[#E5F0FF] text-[#408DFB] hover:bg-[#D0E3FF] transition-colors"
//                   title="View Summary"
//                 >
//                   <DocumentIcon />
//                 </button>

//                 {activeSummaryId === item.id && (
//                   <div
//                     ref={summaryModalRef}
//                     className="absolute z-50 left-1/2 top-full mt-2 border border-[#4285F4] -translate-x-1/2 w-[350px] bg-white rounded-lg shadow-[0_4px_20px_rgba(0,0,0,0.15)] overflow-hidden"
//                     onClick={(e) => e.stopPropagation()}
//                   >
//                     <div className="bg-[#4285F4] px-4 py-2.5 flex items-center gap-2">
//                       <WhiteDocumentIcon />
//                       <h3 className="text-white font-medium font-outfit text-[15px]">
//                         File Summary
//                       </h3>
//                     </div>
//                     <div className="px-3 py-1 max-h-[220px] overflow-y-auto custom-scrollbar">
//                       <p className="text-[#52525B] font-outfit text-[13px] leading-relaxed">
//                         {item.summary}
//                       </p>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>
//         </td>
//       ),
//     },
//     status: {
//       header: (
//         <th
//           key="status"
//           style={getColStyle("status")}
//           className={`${
//             !columnWidths.status ? "w-[22%]" : ""
//           } relative px-3 text-[#00000080] font-outfit text-[13px] font-semibold border-b border-r border-[#0000001A]`}
//         >
//           Status
//           <div
//             onMouseDown={(e) => handleResize("status", e)}
//             className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#A259FF] transition-colors z-10"
//           />
//         </th>
//       ),
//       cell: (item) => (
//         <td
//           key={`status-${item.id}`}
//           style={getColStyle("status")}
//           className={`${
//             !columnWidths.status ? "w-[22%]" : ""
//           } px-3 py-2 border-b border-r border-[#0000001A]`}
//         >
//           {renderStatus(item)}
//         </td>
//       ),
//     },
//     tags: {
//       header: (
//         <th
//           key="tags"
//           style={getColStyle("tags")}
//           className={`${
//             !columnWidths.tags ? "w-[16%]" : ""
//           } relative px-4 text-[#00000080] font-outfit text-[13px] font-semibold border-b border-r border-[#0000001A]`}
//         >
//           Tags
//           <div
//             onMouseDown={(e) => handleResize("tags", e)}
//             className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#A259FF] transition-colors z-10"
//           />
//         </th>
//       ),
//       cell: (item) => (
//         <td
//           key={`tags-${item.id}`}
//           style={getColStyle("tags")}
//           className={`${
//             !columnWidths.tags ? "w-[16%]" : ""
//           } px-1 py-2 border-b border-r border-[#0000001A] max-w-0`}
//         >
//           <DynamicTags
//             tags={item.tags}
//             darkenColor={darkenColor}
//             openTagModalFor={openTagModalFor}
//             itemId={item.id}
//           />
//         </td>
//       ),
//     },
//     uploaded_at: {
//       header: (
//         <th
//           key="uploaded_at"
//           style={getColStyle("uploaded_at")}
//           className={`${
//             !columnWidths.uploaded_at ? "w-[16%]" : ""
//           } relative px-4 text-[#00000080] font-outfit text-[13px] font-semibold cursor-pointer group border-b border-r border-[#0000001A]`}
//         >
//           <div className="flex items-center gap-1.5">
//             Added On
//             <SortIcon />
//           </div>
//           <div
//             onMouseDown={(e) => handleResize("uploaded_at", e)}
//             className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-[#A259FF] transition-colors z-10"
//           />
//         </th>
//       ),
//       cell: (item) => (
//         <td
//           key={`uploaded_at-${item.id}`}
//           style={getColStyle("uploaded_at")}
//           className={`${
//             !columnWidths.uploaded_at ? "w-[16%]" : ""
//           } px-4 py-2 text-[#52525B] font-outfit font-medium text-[13px] border-b border-r border-[#0000001A]`}
//         >
//           {formatDate(item.uploaded_at || item.created_at)}
//         </td>
//       ),
//     },
//   };

//   return (
//     <div className="w-full h-full flex flex-col">
//       <div
//         className="relative overflow-auto custom-scrollbar flex-1 rounded-lg bg-white"
//         ref={tbodyRef}
//       >
//         <table className="w-full table-fixed text-left border-separate border-spacing-0">
//           <thead className="h-[36px] sticky top-0 z-10">
//             <tr className="bg-[#F7F7F7]">
//               <th className="w-[40px] min-w-[40px] pl-3 pr-2 border-b border-[#0000001A]">
//                 <Checkbox
//                   checked={isAllChecked}
//                   onChange={(checked, e) => handleSelectAll(e)}
//                   disabled={displayedFiles.length === 0}
//                   showLabel={false}
//                   size="md"
//                 />
//               </th>

//               {activeColumns.map((col) => columnDefs[col.name]?.header)}

//               <th className="w-[80px] min-w-[80px] px-2 text-[#00000080] font-outfit text-[13px] font-semibold text-center border-b border-[#0000001A]">
//                 Actions
//               </th>
//             </tr>
//           </thead>
//           <tbody className="bg-white">
//             {loading ? (
//               <tr>
//                 <td
//                   colSpan={colSpanCount}
//                   className="py-24 text-center align-middle border-b border-[#0000001A]"
//                 >
//                   <div className="flex flex-col items-center justify-center w-full h-full">
//                     <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#A259FF] mx-auto mb-4"></div>
//                     <p className="text-[#52525B] font-outfit text-[14px]">
//                       {isFolderView
//                         ? "Loading folder contents..."
//                         : "Loading documents..."}
//                     </p>
//                   </div>
//                 </td>
//               </tr>
//             ) : displayedFiles.length > 0 ? (
//               displayedFiles.map((item, index) => (
//                 <tr
//                   key={item.id || index}
//                   className="group hover:bg-[#F8F3FF] transition-colors cursor-default"
//                 >
//                   <td
//                     className="w-[40px] min-w-[40px] pl-3 pr-2 py-2 border-b border-[#0000001A]"
//                     onClick={(e) => e.stopPropagation()}
//                   >
//                     <Checkbox
//                       checked={selectedContracts.includes(item.id)}
//                       onChange={() => handleCheckboxChange(item.id, item.key)}
//                       disabled={!item.id}
//                       showLabel={false}
//                       size="md"
//                     />
//                   </td>

//                   {activeColumns.map((col) => columnDefs[col.name]?.cell(item))}

//                   <td
//                     className="w-[80px] min-w-[80px] px-2 py-2 relative border-b border-[#0000001A]"
//                     onClick={(e) => e.stopPropagation()}
//                   >
//                     <div
//                       onClick={(e) => toggleActionMenu(item.id, e)}
//                       className="cursor-pointer flex items-center w-8 h-8 rounded-md hover:bg-[#A259FF]/10 text-[#A259FF] justify-center transition-colors mx-auto"
//                     >
//                       <ThreeDotsIcon />
//                     </div>
//                     {isActionMenuOpen === item.id && (
//                       <ActionMenu
//                         item={item}
//                         position={actionMenuPosition}
//                         menuRef={(el) => {
//                           if (el) actionMenuRefs.current[item.id] = el;
//                         }}
//                         setSelectedFilePreview={setSelectedFilePreview}
//                         handleRenameClick={handleRenameClick}
//                         handleDownload={handleDownload}
//                         handleDelete={handleDelete}
//                         handleViewAndIngest={handleViewAndIngest}
//                         handleSingleMoveToFolder={handleSingleMoveToFolder}
//                         isAllFilesView={isAllFilesView}
//                         closeMenu={() => setIsActionMenuOpen(null)}
//                       />
//                     )}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td
//                   colSpan={colSpanCount}
//                   className="py-20 text-center border-b border-[#0000001A]"
//                 >
//                   <img
//                     src="/no-contracts.svg"
//                     alt="No Data"
//                     className="mx-auto mb-4 w-32"
//                   />
//                   <p className="text-[15px] font-outfit text-gray-500">
//                     {isFolderView
//                       ? "This folder is empty!"
//                       : "Looks like your table is empty!"}
//                   </p>
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default DataTable;
import React, { useRef, useState, useEffect } from "react";
import Checkbox from "../../../Checkbox";
import ActionMenu from "./ActionMenu";
import { Spinner } from "./FolderPickerModal";
import {
  SpinnerIcon,
  CheckIcon,
  ClockIcon,
  ErrorIcon,
  DocumentIcon,
  WhiteDocumentIcon,
  ThreeDotsIcon,
} from "./Icons";
import DynamicTags from "./DynamicTags";
import FolderCheckBadge from "./FolderCheckBadge";
import { statusKey } from "./kbHelpers";

// The three states shown as grouped sections only when "Previous Proposals"
// ITSELF is open (its nested children — Submitted / Won / Delivered
// in AllSources.jsx's sidebar — already filter to one tier each, so no
// header is needed there). Not separate folders; moving a document between
// groups is a tier change on evidence_tier, never a folder move. Order
// matches the lifecycle: Submitted -> Won -> Delivered. Anything
// not Won/Delivered (a legacy doc with no tier, 'claimed', etc.) reads as
// Submitted rather than vanishing from every group.
const PROPOSAL_TIERS = [
  { key: "past_proposal", label: "Submitted" },
  { key: "won", label: "Won" },
  { key: "delivered", label: "Delivered" },
];
const PROPOSAL_TIER_ORDER = { past_proposal: 0, won: 1, delivered: 2 };
const effectiveProposalTier = (item) =>
  ["won", "delivered"].includes(item.evidence_tier) ? item.evidence_tier : "past_proposal";
const proposalTierRank = (item) => PROPOSAL_TIER_ORDER[effectiveProposalTier(item)];
const proposalTierLabel = (item) =>
  PROPOSAL_TIERS.find((t) => t.key === effectiveProposalTier(item))?.label;

const DataTable = ({
  displayedFiles,
  loading,
  isAllChecked,
  handleSelectAll,
  selectedContracts,
  handleCheckboxChange,
  getFileIcon,
  removeFileExtension,
  darkenColor,
  openTagModalFor,
  applyingTagDocIds = [],
  formatDate,
  toggleActionMenu,
  isActionMenuOpen,
  setIsActionMenuOpen,
  actionMenuPosition,
  actionMenuRefs,
  setSelectedFilePreview,
  handleRenameClick,
  handleDownload,
  handleDelete,
  handleViewAndIngest,
  handleSingleMoveToFolder,
  columnPreferences,
  isFolderView = false,
  isAllFilesView = false,
  isReviewer = false,
  selectedFolderName = null,
  selectedProposalTier = null,
  handleSetProposalTier,
  showFolderColumn = false,
  folderById = {},
  onOpenFolder,
  sortKey = "added",
  sortDir = "desc",
  onSort,
  canDragRows = false,
  onRowDragStart,
  onRowDragEnd,
  emptyState,
  customOrder = false,
  canReorder = false,
  onRowReorder,
  handleRemoveFromFolder,
  pendingDocIds = [],
  onFolderCheckMove,
  onFolderCheckKeep,
}) => {
  const [dragRowId, setDragRowId] = useState(null);
  const [overRowId, setOverRowId] = useState(null);
  const isProposalsFolder = selectedFolderName === "Previous Proposals";
  // Group headers only on the PARENT folder, where all three tiers are mixed
  // together. Inside a nested child (Won / Delivered) the list
  // is already one tier, so a header would just repeat the breadcrumb.
  const showTierGroups = isProposalsFolder && !selectedProposalTier;
  // Stable sort: rows that tie on tier keep the order displayedFiles gave them.
  const rows = showTierGroups
    ? displayedFiles
        .map((item, index) => ({ item, index }))
        .sort((a, b) => proposalTierRank(a.item) - proposalTierRank(b.item) || a.index - b.index)
        .map((entry) => entry.item)
    : displayedFiles;
  const tbodyRef = useRef(null);
  const [activeSummaryId, setActiveSummaryId] = useState(null);
  const summaryModalRef = useRef(null);

  // Columns have fixed design widths; resizing was removed. Clear widths that
  // older builds saved so no one is stuck with a broken layout.
  const columnWidths = {};
  useEffect(() => {
    try {
      localStorage.removeItem("dataTable_columnWidths");
    } catch {}
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        summaryModalRef.current &&
        !summaryModalRef.current.contains(event.target)
      ) {
        setActiveSummaryId(null);
      }
    };

    if (activeSummaryId !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeSummaryId]);

  const [summaryUp, setSummaryUp] = useState(false);
  const toggleSummary = (id, e) => {
    e.stopPropagation();
    const box = tbodyRef.current?.getBoundingClientRect();
    const btn = e.currentTarget.getBoundingClientRect();
    setSummaryUp(!!box && box.bottom - btn.bottom < 280 && btn.top - box.top > 280);
    setActiveSummaryId((prevId) => (prevId === id ? null : id));
  };

  const defaultCols = [
    { name: "name", visible: true, order: 0 },
    { name: "status", visible: true, order: 1 },
    { name: "tags", visible: true, order: 2 },
    { name: "uploaded_at", visible: true, order: 3 },
  ];

  const activeColumns = (
    columnPreferences && columnPreferences.length > 0
      ? columnPreferences
      : defaultCols
  )
    .filter((col) => col.visible === true || col.visible === "true")
    .sort((a, b) => a.order - b.order);

  const colSpanCount =
    2 +
    (activeColumns.length || defaultCols.length) +
    (showFolderColumn ? 1 : 0) +
    (customOrder ? 1 : 0);

  // Below this width the table scrolls sideways instead of squeezing Document to nothing.
  const COL_MIN = { name: 180, status: 170, tags: 140, uploaded_at: 124 };
  const tableMinWidth =
    40 + 64 + (showFolderColumn ? 170 : 0) + (customOrder ? 28 : 0) +
    activeColumns.reduce((sum, col) => sum + (COL_MIN[col.name] || 120), 0);

  const SortArrows = ({ col }) => {
    const active = sortKey === col;
    const up = active ? (sortDir === "asc" ? "#A04A97" : "#A1A1AA") : "#52525B";
    const down = active ? (sortDir === "desc" ? "#A04A97" : "#A1A1AA") : "#52525B";
    return (
      <svg width="12" height="14" viewBox="0 0 12 14" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0">
        <path d="M2 5l4-4 4 4" stroke={up} />
        <path d="M2 9l4 4 4-4" stroke={down} />
      </svg>
    );
  };

  const sortableLabel = (label, col) => (
    <span
      onClick={() => onSort && onSort(col)}
      title={customOrder ? "Sort by this column (replaces the custom order)" : undefined}
      className="inline-flex items-center gap-1.5 whitespace-nowrap cursor-pointer select-none hover:text-[#A04A97]"
    >
      {label}
      <SortArrows col={customOrder ? null : col} />
    </span>
  );

  const renderFolderCell = (item) => {
    const ids = (item.folderIds || []).filter((id) => folderById[id]);
    if (!ids.length) {
      return <span className="font-outfit text-[14px] text-[#71717A]">No folder</span>;
    }
    const first = folderById[ids[0]];
    const others = ids.slice(1).map((id) => folderById[id].name);
    return (
      <div className="flex items-center gap-1.5 min-w-0">
        <span
          onClick={() => onOpenFolder && onOpenFolder(first.id)}
          title={first.name}
          className="min-w-0 inline-flex items-center gap-1.5 font-outfit text-[14px] text-[#27272A] cursor-pointer hover:text-[#A04A97]"
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" className="flex-shrink-0">
            <path d="M3 6a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          </svg>
          <span className="min-w-0 truncate">{first.name}</span>
        </span>
        {others.length > 0 && (
          <span
            title={`Also in ${others.join(", ")}`}
            className="flex-shrink-0 px-1.5 rounded-full bg-[#F4F4F5] border border-[#D4D4D8] font-outfit text-[12px] font-semibold leading-[18px] text-[#3F3F46] cursor-default"
          >
            +{others.length}
          </span>
        )}
      </div>
    );
  };

  const renderStatus = (item) => {
    const rawStatus = item.status || (item.id ? "ready" : "uploading");
    const statusLower = rawStatus.toLowerCase();
    const displayLabel =
      rawStatus.charAt(0).toUpperCase() + rawStatus.slice(1).replace(/_/g, " ");

    let config = {
      label: displayLabel,
      color: "text-[#3F3F46]",
      bg: "bg-[#F1F1F3]",
      border: "border-[#A1A1AA]",
      icon: <SpinnerIcon />,
      isSpinning: true,
    };

    if (
      statusLower === "ready" ||
      statusLower === "ingested" ||
      statusLower === "completed"
    ) {
      config = {
        label: "Ingested",
        color: "text-[#0B6B24]",
        bg: "bg-[#E3F4E8]",
        border: "border-[#6DBA84]",
        icon: <CheckIcon />,
        isSpinning: false,
      };
    } else if (statusLower === "ready_for_review" || statusLower === "ready for review") {
      config = {
        label: "Ready for review",
        color: "text-[#7A5B00]",
        bg: "bg-[#FFF6D6]",
        border: "border-[#D9B53A]",
        icon: <ClockIcon />,
        isSpinning: false,
      };
    } else if (statusLower === "error" || statusLower === "failed") {
      config = {
        label: displayLabel,
        color: "text-red-700",
        bg: "bg-red-50",
        border: "border-red-200",
        icon: <ErrorIcon />,
        isSpinning: false,
      };
    }

    return (
      <span
        title={config.label}
        className={`inline-flex max-w-full font-outfit items-center gap-1.5 px-2.5 py-1 rounded-full border ${config.border} ${config.bg} ${config.color} text-[12px] font-medium`}
      >
        <span
          className={`flex-shrink-0 flex items-center justify-center w-3.5 h-3.5 ${
            config.isSpinning ? "animate-spin" : ""
          }`}
        >
          {config.icon}
        </span>
        <span className="truncate">{config.label}</span>
      </span>
    );
  };

  const getColStyle = (colName) => {
    return columnWidths[colName]
      ? {
          width: columnWidths[colName],
          minWidth: columnWidths[colName],
          maxWidth: columnWidths[colName],
        }
      : {};
  };

  const columnDefs = {
    name: {
      header: (
        <th
          key="name"
          style={getColStyle("name")}
          className={`${
            !columnWidths.name ? "" : ""
          } relative px-4 text-[#00000080] font-outfit text-[13px] font-semibold border-b border-r border-[#0000001A]`}
        >
          {sortableLabel("Document", "name")}
        </th>
      ),
      cell: (item) => (
        <td
          key={`name-${item.id}`}
          style={getColStyle("name")}
          className={`${
            !columnWidths.name ? "" : ""
          } px-4 py-2 border-b border-r border-[#0000001A] relative`}
        >
          <div className="flex items-center gap-3 min-w-0">
            <img
              src={getFileIcon(item)}
              className="w-5 h-5 flex-shrink-0"
              alt="Icon"
            />
            <span
              title={item.name}
              className="min-w-0 text-[#18181B] font-outfit text-[14px] font-medium truncate"
            >
              {removeFileExtension(item.name) || "N/A"}
            </span>
            {pendingDocIds.includes(item.id) && <Spinner color="#A04A97" size={14} />}

            {(item.meta_summary || "").toLowerCase() === "processing" && (
              <span
                className="flex items-center justify-center flex-shrink-0 w-[22px] h-[22px] rounded-full bg-[#E5F0FF] text-[#408DFB]"
                title="Generating summary"
              >
                <SpinnerIcon className="w-3.5 h-3.5 animate-spin" />
              </span>
            )}

            {(item.meta_summary || "").toLowerCase() === "done" && item.summary && (
              <div>
                <button
                  onClick={(e) => toggleSummary(item.id, e)}
                  className="flex items-center justify-center flex-shrink-0 w-[22px] h-[22px] rounded-full bg-[#E5F0FF] text-[#408DFB] hover:bg-[#D0E3FF] transition-colors"
                  title="View Summary"
                >
                  <DocumentIcon />
                </button>

                {activeSummaryId === item.id && (
                  <div
                    ref={summaryModalRef}
                    className={`absolute z-50 left-4 ${summaryUp ? "bottom-full mb-1" : "top-full mt-1"} border border-[#4285F4] w-[350px] bg-white rounded-lg shadow-[0_4px_20px_rgba(0,0,0,0.15)] overflow-hidden`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="bg-[#4285F4] px-4 py-2.5 flex items-center gap-2">
                      <WhiteDocumentIcon />
                      <h3 className="text-white font-medium font-outfit text-[15px]">
                        File Summary
                      </h3>
                    </div>
                    <div className="px-3 py-1 max-h-[220px] overflow-y-auto custom-scrollbar">
                      <p className="text-[#52525B] font-outfit text-[13px] leading-relaxed">
                        {item.summary}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </td>
      ),
    },
    status: {
      header: (
        <th
          key="status"
          style={getColStyle("status")}
          className={`${
            !columnWidths.status ? "w-[170px] min-w-[170px]" : ""
          } relative px-3 text-[#00000080] font-outfit text-[13px] font-semibold border-b border-r border-[#0000001A]`}
        >
          {sortableLabel("Status", "status")}
        </th>
      ),
      cell: (item) => (
        <td
          key={`status-${item.id}`}
          style={getColStyle("status")}
          className={`${
            !columnWidths.status ? "w-[170px] min-w-[170px]" : ""
          } px-3 py-2 border-b border-r border-[#0000001A]`}
        >
          {item.folder_check && ["review", "ingested"].includes(statusKey(item.status)) ? (
            <div className="flex flex-col items-start gap-1 min-w-0">
              {renderStatus(item)}
              <FolderCheckBadge
                item={item}
                isReviewer={isReviewer}
                onMove={onFolderCheckMove}
                onKeep={onFolderCheckKeep}
              />
            </div>
          ) : (
            renderStatus(item)
          )}
        </td>
      ),
    },
    tags: {
      header: (
        <th
          key="tags"
          style={getColStyle("tags")}
          className={`${
            !columnWidths.tags ? "w-[140px] min-w-[140px]" : ""
          } relative px-4 text-[#00000080] font-outfit text-[13px] font-semibold border-b border-r border-[#0000001A]`}
        >
          Tags
        </th>
      ),
      cell: (item) => (
        <td
          key={`tags-${item.id}`}
          style={getColStyle("tags")}
          className={`${
            !columnWidths.tags ? "w-[140px] min-w-[140px]" : ""
          } px-1 py-2 border-b border-r border-[#0000001A] max-w-0`}
        >
          {/* A file still being sent has no id to tag yet. */}
          {item.id && (
            <DynamicTags
              tags={item.tags}
              darkenColor={darkenColor}
              openTagModalFor={openTagModalFor}
              itemId={item.id}
              isReviewer={isReviewer}
              isApplying={applyingTagDocIds.includes(item.id)}
            />
          )}
        </td>
      ),
    },
    uploaded_at: {
      header: (
        <th
          key="uploaded_at"
          style={getColStyle("uploaded_at")}
          className={`${
            !columnWidths.uploaded_at ? "w-[124px] min-w-[124px]" : ""
          } relative px-4 text-[#00000080] font-outfit text-[13px] font-semibold cursor-pointer group border-b border-r border-[#0000001A]`}
        >
          {sortableLabel("Added On", "added")}
        </th>
      ),
      cell: (item) => (
        <td
          key={`uploaded_at-${item.id}`}
          style={getColStyle("uploaded_at")}
          className={`${
            !columnWidths.uploaded_at ? "w-[124px] min-w-[124px]" : ""
          } px-4 py-2 whitespace-nowrap text-[#52525B] font-outfit font-medium text-[13px] border-b border-r border-[#0000001A]`}
        >
          {formatDate(item.uploaded_at || item.created_at)}
        </td>
      ),
    },
  };

  // The Folder column is not a user-configurable column: it only exists in All
  // Files and always sits right after Document.
  const withFolderColumn = (cells, folderCell) => {
    if (!showFolderColumn) return cells;
    const at = activeColumns.findIndex((c) => c.name === "name");
    const out = [...cells];
    out.splice(at === -1 ? 0 : at + 1, 0, folderCell);
    return out;
  };

  const folderHeader = (
    <th
      key="folder"
      className="w-[170px] min-w-[170px] px-3 text-[#00000080] font-outfit text-[13px] font-semibold border-b border-r border-[#0000001A]"
    >
      Folder
    </th>
  );

  const folderCell = (item) => (
    <td
      key={`folder-${item.id}`}
      className="w-[170px] min-w-[170px] max-w-[170px] px-3 py-2 border-b border-r border-[#0000001A]"
    >
      {renderFolderCell(item)}
    </td>
  );

  const empty = emptyState || {
    title: isFolderView ? "This folder is empty" : "No documents yet",
    body: isFolderView
      ? "Documents added to this folder will appear here. Move or upload files to get started."
      : "Upload your documents to build your knowledge base. They'll show up here once added.",
  };

  return (
    <div className="w-full h-full flex flex-col">
      <div
        className="relative overflow-auto custom-scrollbar flex-1 rounded-lg bg-white"
        ref={tbodyRef}
        onScroll={() => setIsActionMenuOpen(null)}
      >
        <table
          className="w-full table-fixed text-left border-separate border-spacing-0"
          style={{ minWidth: tableMinWidth }}
        >
          <thead className="h-[36px] sticky top-0 z-10">
            <tr className="bg-[#F7F7F7]">
              {customOrder &&<th className="w-[28px] min-w-[28px] border-b border-[#0000001A]" />}
              <th className="w-[40px] min-w-[40px] pl-3 pr-2 border-b border-[#0000001A]">
                <Checkbox
                  checked={isAllChecked}
                  onChange={(checked, e) => handleSelectAll(e)}
                  disabled={displayedFiles.length === 0}
                  showLabel={false}
                  size="md"
                />
              </th>

              {withFolderColumn(
                activeColumns.map((col) => columnDefs[col.name]?.header),
                folderHeader
              )}

              <th className="w-[64px] min-w-[64px] px-1 text-[#00000080] font-outfit text-[13px] font-semibold text-center border-b border-[#0000001A]">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {loading ? (
              Array.from({ length: 8 }).map((_, rowIdx) => (
                <tr key={`skeleton-${rowIdx}`} className="animate-pulse">
                  {/* Checkbox column */}
                  <td className="w-[40px] min-w-[40px] pl-3 pr-2 py-[14px] border-b border-[#0000001A]">
                    <div className="h-4 w-4 rounded bg-[#E5E7EB]" />
                  </td>
                  {activeColumns.map((col, colIdx) => (
                    <td
                      key={`skeleton-${rowIdx}-${col.name}`}
                      className="px-2 py-[14px] border-b border-[#0000001A]"
                    >
                      <div
                        className="h-3.5 rounded bg-[#E5E7EB]"
                        style={{ width: `${[75, 50, 65, 55][colIdx % 4]}%` }}
                      />
                    </td>
                  ))}
                  {/* Actions column */}
                  <td className="w-[64px] min-w-[64px] px-1 py-[14px] border-b border-[#0000001A]">
                    <div className="h-3.5 w-5 rounded bg-[#E5E7EB] mx-auto" />
                  </td>
                </tr>
              ))
            ) : rows.length > 0 ? (
              rows.map((item, index) => {
                const prevItem = rows[index - 1];
                const showGroupHeader =
                  showTierGroups &&
                  (index === 0 || proposalTierRank(item) !== proposalTierRank(prevItem));

                return (
                <React.Fragment key={item.id || item.key || index}>
                {showGroupHeader && (
                  <tr>
                    <td colSpan={colSpanCount} className="px-3 pt-3 pb-1.5 bg-white border-b border-[#0000000D]">
                      <span className="text-[12px] font-semibold uppercase tracking-[0.05em] text-[#A1A1AA]">
                        {proposalTierLabel(item)}
                      </span>
                    </td>
                  </tr>
                )}
                <tr
                  draggable={canDragRows && !!item.id}
                  onDragStart={(e) => {
                    e.dataTransfer.effectAllowed = "copyMove";
                    e.dataTransfer.setData("text/plain", item.name || "");
                    setDragRowId(item.id);
                    if (onRowDragStart) onRowDragStart(item);
                  }}
                  onDragOver={(e) => {
                    if (!canReorder || !dragRowId) return;
                    e.preventDefault();
                    if (overRowId !== item.id) setOverRowId(item.id);
                  }}
                  onDrop={(e) => {
                    if (!canReorder || !dragRowId) return;
                    e.preventDefault();
                    if (onRowReorder && dragRowId !== item.id) onRowReorder(dragRowId, item.id);
                    setOverRowId(null);
                  }}
                  onDragEnd={() => {
                    setDragRowId(null);
                    setOverRowId(null);
                    if (onRowDragEnd) onRowDragEnd();
                  }}
                  title={
                    canDragRows && item.id
                      ? canReorder
                        ? "Drag onto another row to reorder, or onto a folder to move it there"
                        : "Drag onto a folder to move it there"
                      : undefined
                  }
                  className={`group hover:bg-[#F8F3FF] transition-colors ${
                    canDragRows && item.id ? "cursor-grab" : "cursor-default"
                  } ${dragRowId === item.id ? "bg-[#F4F0F8]" : ""} ${
                    pendingDocIds.includes(item.id) ? "opacity-50 pointer-events-none" : ""
                  } ${
                    canReorder && overRowId === item.id && dragRowId !== item.id
                      ? "shadow-[inset_0_2px_0_#A04A97]"
                      : ""
                  }`}
                >
                  {customOrder && (
                    <td className="w-[28px] min-w-[28px] border-b border-[#0000001A] text-center">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="#52525B" className="inline-block">
                        <circle cx="9" cy="6" r="1.6" />
                        <circle cx="15" cy="6" r="1.6" />
                        <circle cx="9" cy="12" r="1.6" />
                        <circle cx="15" cy="12" r="1.6" />
                        <circle cx="9" cy="18" r="1.6" />
                        <circle cx="15" cy="18" r="1.6" />
                      </svg>
                    </td>
                  )}
                  <td
                    className="w-[40px] min-w-[40px] pl-3 pr-2 py-2 border-b border-[#0000001A]"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Checkbox
                      checked={selectedContracts.includes(item.id)}
                      onChange={() => handleCheckboxChange(item.id, item.key)}
                      disabled={!item.id}
                      showLabel={false}
                      size="md"
                    />
                  </td>

                  {withFolderColumn(
                    activeColumns.map((col) => columnDefs[col.name]?.cell(item)),
                    folderCell(item)
                  )}

                  <td
                    className="w-[64px] min-w-[64px] px-1 py-2 relative border-b border-[#0000001A]"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {item.id && (
                      <div
                        onClick={(e) => toggleActionMenu(item.id, e)}
                        className="cursor-pointer flex items-center w-8 h-8 rounded-md hover:bg-[#A259FF]/10 text-[#A259FF] justify-center transition-colors mx-auto"
                      >
                        <ThreeDotsIcon />
                      </div>
                    )}
                    {item.id && isActionMenuOpen === item.id && (
                      <ActionMenu
                        item={item}
                        position={actionMenuPosition}
                        menuRef={(el) => {
                          if (el) actionMenuRefs.current[item.id] = el;
                        }}
                        setSelectedFilePreview={setSelectedFilePreview}
                        handleRenameClick={handleRenameClick}
                        handleDownload={handleDownload}
                        handleDelete={handleDelete}
                        handleViewAndIngest={handleViewAndIngest}
                        handleSingleMoveToFolder={handleSingleMoveToFolder}
                        handleRemoveFromFolder={handleRemoveFromFolder}
                        isAllFilesView={isAllFilesView}
                        closeMenu={() => setIsActionMenuOpen(null)}
                        isReviewer={isReviewer}
                        isProposalsFolder={isProposalsFolder}
                        handleSetProposalTier={handleSetProposalTier}
                      />
                    )}
                  </td>
                </tr>
                </React.Fragment>
                );
              })
            ) : (
              <tr className="hover:!bg-white hover:!shadow-none">
                <td
                  colSpan={colSpanCount}
                  className="py-20 text-center"
                >
                  <img
                    src="/no-contracts.svg"
                    alt="No Data"
                    className="mx-auto mb-4 w-32"
                  />
                  <p className="text-[17px] font-outfit font-semibold text-[#18181B] mb-1.5">
                    {empty.title}
                  </p>
                  <p className="text-[14px] font-outfit text-[#3F3F46] max-w-[360px] mx-auto leading-relaxed">
                    {empty.body}
                  </p>
                  {empty.actionLabel && (
                    <button
                      type="button"
                      onClick={empty.onAction}
                      className="mt-4 px-4 py-[7px] border border-[#A04A97] rounded-md bg-white text-[#A04A97] font-outfit text-[14px] font-semibold hover:bg-[#FDF2F8]"
                    >
                      {empty.actionLabel}
                    </button>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataTable;